import {
  MdAnalytics,
  MdAttachMoney,
  MdSchool,
  MdPeople,
  MdCampaign,
  MdDashboard,
  MdOutlineSchool,
  MdOutlineScience,
  MdOutlineAttachMoney,
  MdOutlineEdit,
  MdOutlineWork,
  MdOutlineMentor,
  MdOutlineMiscellaneousServices,
} from "react-icons/md";
import ServiceImage1 from "../../Assets/img/service/scientific.jpeg";
import ServiceImage2 from "../../Assets/img/service/application.jpeg";
import ServiceImage3 from "../../Assets/img/service/studyy.png";
import ServiceImage4 from "../../Assets/img/service/working.jpeg";
import ServiceImage5 from "../../Assets/img/service/mentorship.jpeg";
import ServiceImage6 from "../../Assets/images/family-enjoying-their-trip-paris.jpg";
import ServiceImage7 from "../../Assets/img/service/working.jpeg";

const servicesData = [
  {
    
    
      id: 1,
      title: "Scientific and Academic Writing",
      description:
        "Enhance your communication skills for academic and professional success with expert support.",
      details:
        "In today’s career landscape, effective communication—both oral and written—has become an increasingly vital skill, complementing academic achievement. At PAC, we offer comprehensive training in developing and writing research proposals, executing research projects, and transforming research reports into publishable scientific manuscripts. \n\nOur services include crafting concept notes, developing research proposals, and providing support for dissertations, theses, and academic reports. We also assist with manuscript preparation, journal article submissions, and navigating the peer review process. Additionally, our expert team offers professional review and constructive feedback on academic documents, helping learners achieve their communication goals and succeed in academia.",
      image: ServiceImage1,
      icon: <MdOutlineEdit />,

    featureTitle: "Features",    
    features: [
      "Concept notes",
      "Research proposal",
      "Research project report/dissertation/thesis",
      "Professional review and feedback on academic writings",
      "Manuscript writing",
      "Handling journal article submission",
      "Peer review process and handling reviewers’ feedback",
    ],
    testimonial: {
      quote:
        "During my final year in the MSc Adult Nursing program at the University of Hertfordshire, I recognized the need for professional proofreading support for my dissertation. I sought the expertise of Dr. Godfrey Mayoka, who willingly agreed to assist, requesting an early submission to allow sufficient time for comprehensive feedback. Despite not having a nursing background, Dr. Mayoka quickly understood the dissertation topic, Catheter Passport, and provided insightful feedback. His suggestions included clarifying complex sections, condensing content where necessary, and enhancing the overall coherence of the document. Following his guidance, the dissertation received a distinction, contributing significantly to the successful completion of the program with distinction. His intellectual input was instrumental in refining the quality of the work, and I remain deeply appreciative of the support provided.",
      author: " Horetius Malenya Okanga, 	Adult Registered Nurse – England",
    },
  },
 
  {
    id: 3,
    title: "Study Abroad",
    description:
      "Receive expert guidance on choosing the right destination, course selection, and navigating the application process.",
    details:
      "Achieving career goals and gaining global perspectives often requires exploring educational opportunities beyond one’s native environment. However, choosing the right destination, selecting a suitable course, and navigating the application process can be daunting, especially for first-time applicants. With extensive experience in studying, traveling, and networking across different continents, the PAC team is uniquely positioned to guide and support individuals embarking on this journey—whether it's their first time or they’re seeking advice from seasoned professionals.When considering study destinations around the world, several key factors come into play, including the availability of specific courses, language of instruction, tuition fees, living costs, cultural experience, and the potential for post-study work opportunities. At PAC, we provide valuable insights into these differentiating factors, helping you make informed decisions as you explore global education options..",
    image: ServiceImage3,
    icon: <MdOutlineSchool />,
    "faq": {
      "p": "[Studying across world regions: What does it take?]",
      "link": "https://path/study.pdf",
      "title": "(Content created for some regions, see separate documents)"
    },
    

    featureTitle: "Regions",

    features: [
      "North America: US and Canada",
      "United Kingdom and Europe",
      "Australia and New Zealand",
      "South Africa ",
      "China, Japan, Singapore",
    ],
    testimonial: {
      quote:
        'I am immensely grateful for the support I received from Dr. Godfrey Mayoka, which was instrumental in my journey to becoming a PhD candidate at the West African Centre for Cell Biology of Infectious Pathogens (WACCBIP), University of Ghana, Accra, Ghana. Through his mentorship, I gained invaluable guidance in seeking university admission and scholarships, along with several recommendation letters and strategic advice. His insights shaped my scientific thinking and professional development, providing me with the clarity and confidence to pursue my goals. Thanks to his unwavering support, I am now well on my way to making meaningful contributions to infectious disease research. ',
      author: "DFagdeba David Bara, Togo",
    },
  },
  {
    id: 4,
    title: "Working Abroad",
    description:
      "Discover job opportunities overseas and get tailored guidance for a successful career transition.",
    details:
      "Whether you’re seeking to gain further experience or maximize the return on your career investment, working abroad can be a highly rewarding opportunity. However, much like studying abroad, pursuing a job overseas requires careful consideration. It&#39;s crucial to identify which countries offer opportunities in your field, understand the working conditions and evaluate the prospects for career growth and development.",
    image: ServiceImage4,
    icon: <MdOutlineWork />,
    "faq": {
      "p": "[How do I navigate the process and how should I prepare?]",
      "link": "https://path/study.pdf",
      "title": "(Content created for some regions, see separate documents)"
    },
    featureTitle: "Regions",
    features: [
      "North America: US and Canada",
      "United Kingdom and Europe",
      "Australia and New Zealand",
      "South Africa ",
      "China, Japan, Singapore",
    ],
    testimonial: {
      quote:
        "My name is Dr. Veronica Njambi Kihugi, and I sought to enhance my academic and research writing skills to advance my career as a pharmacist. Under the mentorship of Dr. Godfrey Mayoka, I gained invaluable insights into the entire research process—from conceptualization to publication. He not only taught me how to be an effective an impactful writer but also how to distinguish myself in my field. Through his guidance, I successfully published over five research papers, addressing critical topics such as transfusion processes in clinical settings and pandemic-driven learning inequalities in Kenya. His mentorship also inspired me to pursue a master’s in public health (Applied Epidemiology), which has been instrumental in my current work in health financing and research. Dr. Mayoka’s unwavering support has been pivotal in shaping my skills and transforming me into a confident professional, well-equipped to excel in my field. I am deeply grateful for his mentorship and am confident that with his continued guidance, I will achieve even greater milestones in my career.",
      author: "Dr. Veronica Njambi Kihugi, Pharmacist, Researcher, and Public Health Specialis",
    },
  },
  {
    id: 5,
    title: "Academic and Professions Mentorship",
    description:
      "Career guidance for students and professionals, powered by our extensive network and experience.",
    details:
      "We believe strongly in the power of mentorship. A mentor can provide invaluable guidance,helping you navigate your educational journey, fast-track your career, and avoid less rewarding or distracting paths by sharing their own experiences. At PAC, our mentorship programs offer career guidance for pre-university and university students, as well as early- career professionals. These programs draw on the personal experiences of our team and the expertise within our extensive network.",
    image: ServiceImage5,
    icon: <MdPeople />,
    // features: [
    //   "Concept notes",
    //   "Research proposal",
    //   "Research project report/dissertation/thesis",
    //   "Professional review and feedback on academic writings",
    //   "Manuscript writing",
    //   "Handling journal article submission",
    //   "Peer review process and handling reviewers’ feedback",
    // ],
    testimonial: {
      quote:
        "My name is Consolata Nsanzubuhoro, and I am a PhD candidate at Stellenbosch University, South Africa. I am honoured to share my experience with Pristine Academic Consultancy and the transformative mentorship of Dr. Godfrey Mayoka. Over the past eight years, Dr. Mayoka’s guidance has been instrumental in shaping my academic journey. With his mentorship, I successfully completed my master’s thesis at the University of Cape Town and secured a prestigious PhD fellowship at Stellenbosch University. His expertise in academic writing has provided me with essential skills that have significantly contributed to my professional growth. I highly recommend Pristine Academic Consultancy to anyone seeking to excel in their academic and professional pursuits. Their services are invaluable, and I am confident they will continue to empower many others to achieve their goals.",
      author: "Consolata Nsanzubuhoro, PhD candidate at Stellenbosch University, South Africa.",
    },
  },
  {
    id: 2,
    title: "Application Support and Professional Writing",
    description:
      "We assist our clients to improve their personal statements, CVs, cover letters, and other forms of professional communication.",
    details:
      "In academic, professional, or career development, applying for admission to academic institutions or seeking financial support through scholarships, fellowships, or grants is often necessary. As part of these applications, candidates may need to demonstrate their suitability through personal statements, motivational letters, or similar documents. Developing skills in official writing—such as crafting letters, cover letters, CVs, and professional emails—can significantly enhance one’s competitiveness in today’s highly competitive education and job markets. Drawing from our experience and extensive networks, the PAC team is pleased to offer guidance and support throughout",
    image: ServiceImage2,
    icon: <MdOutlineEdit />,
    
    // features: [
    //   "Concept notes",
    //   "Research proposal",
    //   "Research project report/dissertation/thesis",
    //   "Professional review and feedback on academic writings",
    //   "Manuscript writing",
    //   "Handling journal article submission",
    //   "Peer review process and handling reviewers’ feedback",
    // ],
    testimonial: {
      quote:
      "My name is Faithful, and I reached out to Pristine Academic Consultancy while applying for the Commonwealth Shared Scholarship, UK, to pursue an MSc in Financial Technology (FinTech) at the University of Stirling. Their support was exceptional—they provided detailed and insightful reviews of my application essays, offering clear and actionable guidance for improvement. After I implemented the suggestions, they conducted another thorough review with a professional lens, ensuring my essays were polished and complete. Their input was invaluable, and I successfully secured this prestigious scholarship. Beyond the technical review, their moral and inspirational support boosted my confidence immensely. I wholeheartedly recommend Pristine Academic Consultancy for their outstanding educational services—they truly exceed expectations.",    
      author: "Faithful Chiagoziem ONWUEGBUCHE",
    },
  },

]


export default servicesData;
